import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useScreenStore } from '@/stores/index.js'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import '@/assets/css/bootstrap.css';
import '@/assets/css/style.css';
import '@/assets/css/index.css';
import '@/assets/css/responsive.css';
import "@/style/style.scss";

/*图标*/
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import utils from '@/utils/index.js'
import XEUtils from 'xe-utils'//工具类
import components from './components'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(components)
app.use(createPinia())
// 初始化屏幕监听
const screenStore = useScreenStore()
screenStore.initScreenListener()
// 将isMobile属性添加到全局属性中
app.config.globalProperties.$isMobile = useScreenStore().isMobile
app.config.globalProperties.$screenWidth = useScreenStore().screenWidth

// 注册全局 $store
app.config.globalProperties.$store = {
  screen: useScreenStore(),
}
app.config.globalProperties.XEUtils = XEUtils
app.config.globalProperties.$utils = utils
app.config.globalProperties.moment = moment
app.use(router)
app.use(ElementPlus)
app.mount('#app')
